import { ChangeEvent, useCallback } from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { UserFormData } from '../../add-user-dialog/user-form-page';

import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';

interface ManagerEmailTextFieldProps {
  watch: UseFormWatch<UserFormData>;
  setValue: UseFormSetValue<UserFormData>;
  disabled: boolean;
}

export default function ManagerEmailTextField({
  watch,
  setValue,
  disabled,
}: ManagerEmailTextFieldProps) {
  const relations = watch('relations');

  const handleManagerEmailChange = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const managers =
        relations?.filter((relation) => relation.type === 'manager') || [];
      const hasManagers = managers.length > 0;

      if (hasManagers) {
        if (e.target.value === '' && managers.length === 1) {
          setValue(
            'relations',
            relations?.filter((relation) => relation.type !== 'manager'),
            { shouldDirty: true }
          );
          return;
        } else {
          let foundManager = false;
          setValue(
            'relations',
            relations?.map((relation) => {
              if (relation.type === 'manager' && !foundManager) {
                foundManager = true;
                return { ...relation, value: e.target.value };
              }
              return relation;
            }),
            { shouldDirty: true }
          );
        }
      } else {
        setValue(
          'relations',
          [
            ...(relations || []),
            {
              type: 'manager',
              customType: '',
              value: e.target.value,
            },
          ],
          { shouldDirty: true }
        );
      }
    },
    [relations, setValue]
  );

  return (
    <Tooltip
      arrow
      title={
        disabled
          ? `You need the "Edit Relationships" permission to edit this field.`
          : ''
      }
    >
      <span>
        <TextField
          value={relations?.find((rel) => rel.type === 'manager')?.value || ''}
          onChange={(e) => handleManagerEmailChange(e)}
          autoComplete="off"
          label="Manager's Email"
          sx={{ minWidth: 400 }}
          disabled={disabled}
        />
      </span>
    </Tooltip>
  );
}
